import { render, staticRenderFns } from "./ProductByOrder.vue?vue&type=template&id=3ab16671"
import script from "./ProductByOrder.vue?vue&type=script&lang=js"
export * from "./ProductByOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports